import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = { key: 1 }
const _hoisted_2 = { style: {"text-align":"center"} }
const _hoisted_3 = ["src"]
const _hoisted_4 = ["src"]
const _hoisted_5 = ["src"]
const _hoisted_6 = ["src"]

import { computed } from 'vue'
import { CoursewareType } from '../config'
import PlanPreview from '@/views/courseware-square/components/PlanPreview.vue'


export default /*#__PURE__*/_defineComponent({
  props: {
  visible: {
    type: Boolean,
    default: false
  },
  currentPreview: {
    type: Object
  },
  data: {
    type: String,
    default: null
  }
},
  emits: ['onCancel'],
  setup(__props, { emit }) {

const props = __props


const currentPreviewCompu = computed(() => props.currentPreview)
const visibleCompu = computed(() => props.visible)

const content = computed(() => props.data)

console.log(content)



const handlePreviewCancel = () => {
  emit('onCancel')
}

return (_ctx: any,_cache: any) => {
  const _component_a_tooltip = _resolveComponent("a-tooltip")!
  const _component_a_modal = _resolveComponent("a-modal")!
  const _directive_nopreventright = _resolveDirective("nopreventright")!

  return (_unref(visibleCompu))
    ? (_openBlock(), _createBlock(_component_a_modal, {
        key: 0,
        visible: _unref(visibleCompu),
        onCancel: handlePreviewCancel,
        destroyOnClose: "",
        maskClosable: false,
        width: _unref(currentPreviewCompu)?.type === _unref(CoursewareType).AUDIO ? 500 : 1000,
        footer: null,
        style: _normalizeStyle(
      _unref(currentPreviewCompu)?.type === _unref(CoursewareType).AUDIO ? {} : { top: '20px' }
    )
      }, {
        title: _withCtx(() => [
          _createElementVNode("span", null, [
            (_unref(currentPreviewCompu)?.name?.length > 15)
              ? (_openBlock(), _createBlock(_component_a_tooltip, {
                  key: 0,
                  title: _unref(currentPreviewCompu)?.name
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(" 预览课件: " + _toDisplayString(_unref(currentPreviewCompu)?.name.slice(0, 14)) + "... ", 1)
                  ]),
                  _: 1
                }, 8, ["title"]))
              : (_openBlock(), _createElementBlock("span", _hoisted_1, "预览课件: " + _toDisplayString(_unref(currentPreviewCompu)?.name), 1))
          ])
        ]),
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_2, [
            (_unref(currentPreviewCompu)?.type === _unref(CoursewareType).IMAGE)
              ? _withDirectives((_openBlock(), _createElementBlock("img", {
                  key: 0,
                  style: {"max-width":"100%","max-height":"80vh"},
                  src: _unref(currentPreviewCompu)?.url
                }, null, 8, _hoisted_3)), [
                  [_directive_nopreventright]
                ])
              : _createCommentVNode("", true),
            (_unref(currentPreviewCompu)?.type === _unref(CoursewareType).VIDEO)
              ? _withDirectives((_openBlock(), _createElementBlock("video", {
                  key: 1,
                  style: {"width":"100%"},
                  controls: "",
                  src: _unref(currentPreviewCompu)?.url,
                  controlslist: "nodownload"
                }, null, 8, _hoisted_4)), [
                  [_directive_nopreventright]
                ])
              : _createCommentVNode("", true),
            (_unref(currentPreviewCompu)?.type === _unref(CoursewareType).AUDIO)
              ? _withDirectives((_openBlock(), _createElementBlock("audio", {
                  key: 2,
                  style: {"width":"100%"},
                  controls: "",
                  src: _unref(currentPreviewCompu)?.url,
                  controlslist: "nodownload"
                }, null, 8, _hoisted_5)), [
                  [_directive_nopreventright]
                ])
              : _createCommentVNode("", true),
            (_unref(currentPreviewCompu)?.type === _unref(CoursewareType).SPEAK)
              ? _withDirectives((_openBlock(), _createElementBlock("video", {
                  key: 3,
                  style: {"width":"100%"},
                  controls: "",
                  src: _unref(currentPreviewCompu)?.url,
                  controlslist: "nodownload"
                }, null, 8, _hoisted_6)), [
                  [_directive_nopreventright]
                ])
              : _createCommentVNode("", true),
            (_unref(currentPreviewCompu)?.type === _unref(CoursewareType).PLAN)
              ? _withDirectives((_openBlock(), _createBlock(PlanPreview, {
                  key: 4,
                  content: _unref(content),
                  style: {"width":"100%"},
                  controls: ""
                }, null, 8, ["content"])), [
                  [_directive_nopreventright]
                ])
              : _createCommentVNode("", true)
          ])
        ]),
        _: 1
      }, 8, ["visible", "width", "style"]))
    : _createCommentVNode("", true)
}
}

})